import  { Component } from 'react';
import { safeSetTextContent, validateAndSanitizeInput } from '../../utils/SafeDOMUtil';


class BottomAlert extends Component {

     componentDidMount =() =>{
          let bottomAlert = document.getElementById("bottom_alert");
          console.log("bottomAlert",bottomAlert)
          let status =this.props.status?this.props.status:"default"
          if (bottomAlert) {
               bottomAlert.classList.add(("alert_"+status),"show");
          }
          
          // Use safe DOM manipulation instead of innerHTML
          const msgElement = document.querySelector(".bottom_alert .msg");
          if (msgElement && msgElement instanceof HTMLElement) {
               const msg = this.props.msg ? this.props.msg : 'Alert';
               // Validate and sanitize input before display
               const validation = validateAndSanitizeInput(msg, 500);
               if (validation.isValid) {
                    safeSetTextContent(msgElement, validation.sanitized);
               } else {
                    safeSetTextContent(msgElement, 'Alert'); // Fallback to safe default
                    console.warn('BottomAlert: Invalid message content', validation.error);
               }
          }
          
          document.querySelector(".bottom_alert .close_bottom_alert").addEventListener("click", function(){
               if (bottomAlert) {
                    bottomAlert.classList.remove("show");
               }
          });
          setTimeout(() => {
               if (bottomAlert) {
                    bottomAlert.classList.remove("show");
               }
               if(!!this.props.onHide){
                    this.props.onHide();
               }
          }, this.props.time ? this.props.time : 5000 );

     }
     render = () => {
          return (null);
     }
}

export default BottomAlert;


// Usage:
// <BottomAlert msg="Alert" status="danger" />
// <BottomAlert msg="Alert" status="success" />
// <BottomAlert msg="Alert" status="danger" />